// Diff view — plan §4.5.4 orijinal AI çıktısı vs düzeltilmiş content.
// Karar #2: jsdiff diffLines (paragraph-based, rapor için anlamlı).

import { diffLines, type Change } from "diff";
import { useMemo } from "react";

export interface DiffViewProps {
  original: string;
  current: string;
}

export function DiffView({ original, current }: DiffViewProps): JSX.Element {
  const parts: Change[] = useMemo(
    () => diffLines(original ?? "", current ?? "", { ignoreWhitespace: false }),
    [original, current],
  );

  if (parts.length === 1 && !parts[0]!.added && !parts[0]!.removed) {
    return (
      <div
        className="p-4 rounded"
        style={{
          background: "var(--color-bg)",
          color: "var(--color-text-3)",
          border: "1px dashed var(--color-border)",
        }}
      >
        <p className="text-sm">Orijinal AI çıktısı ile güncel içerik aynı.</p>
      </div>
    );
  }

  return (
    <div
      className="rounded overflow-auto"
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: "0.78rem",
        border: "1px solid var(--color-border)",
        background: "var(--color-surface)",
      }}
    >
      {parts.map((part, idx) => {
        let bg = "transparent";
        let color = "var(--color-text)";
        let marker = " ";
        if (part.added) {
          bg = "color-mix(in srgb, var(--color-success) 10%, white)";
          color = "var(--color-success)";
          marker = "+";
        } else if (part.removed) {
          bg = "color-mix(in srgb, var(--color-error) 10%, white)";
          color = "var(--color-error)";
          marker = "−";
        }
        return (
          <div
            key={idx}
            style={{
              background: bg,
              color,
              padding: "4px 12px",
              whiteSpace: "pre-wrap",
              borderBottom: "1px solid var(--color-border)",
            }}
          >
            <span style={{ opacity: 0.5, marginRight: 8, userSelect: "none" }}>{marker}</span>
            {part.value}
          </div>
        );
      })}
    </div>
  );
}
